import { isDingTalkEnvironment, isFeishuEnvironment } from './device-detect.js'

/**
 * 跳转到钉钉企业入口页
 * @param {{ targetUrl?: string, corpId?: string, tenantId?: string }} opts
 */
export function redirectToDingTalkEnterpriseEntry(opts = {}) {
  const targetUrl = opts.targetUrl || localStorage.getItem('targetUrl') || window.location.href
  const corpId = opts.corpId ?? localStorage.getItem('corpId') ?? ''
  const tenantId = opts.tenantId ?? localStorage.getItem('tenantId') ?? ''

  const params = new URLSearchParams()
  if (corpId) params.set('corpId', corpId)
  // 兼容 dingtalk-enterprise-entry.vue 内同时读取 corpid/corpId
  if (corpId) params.set('corpid', corpId)
  if (tenantId) params.set('tenantId', tenantId)
  params.set('targetUrl', targetUrl)

  window.location.href = `/#/dingtalk-enterprise-entry?${params.toString()}`
}

/**
 * 跳转到飞书企业入口页
 * @param {{ targetUrl?: string, appId?: string, tenantId?: string }} opts
 */
export function redirectToLarkEnterpriseEntry(opts = {}) {
  const targetUrl = opts.targetUrl || localStorage.getItem('targetUrl') || window.location.href
  const appId = opts.appId ?? localStorage.getItem('appId') ?? ''
  const tenantId = opts.tenantId ?? localStorage.getItem('tenantId') ?? ''

  const params = new URLSearchParams()
  if (appId) params.set('appId', appId)
  if (tenantId) params.set('tenantId', tenantId)
  params.set('targetUrl', targetUrl)

  window.location.href = `/#/lark-enterprise-entry?${params.toString()}`
}

/**
 * 未登录/401 统一跳转：
 * - 清 token
 * - 保存当前完整链接到 localStorage.targetUrl
 * - 按环境（钉钉/飞书）跳企业入口页，否则去 /#/login
 * - 避免在入口页/登录页死循环
 *
 * @param {{ targetUrl?: string, clearToken?: boolean }} opts
 */
export function handleUnauthorizedRedirect(opts = {}) {
  const fullUrl = opts.targetUrl || window.location.href

  // 默认清 token
  if (opts.clearToken !== false) {
    localStorage.removeItem('token')
  }

  // 保存当前完整链接（后续登录成功后回跳）
  localStorage.setItem('targetUrl', fullUrl)

  // 避免在登录入口页/登录页被触发无限重定向
  const hash = window.location.hash || ''
  if (
    hash.startsWith('#/dingtalk-enterprise-entry') ||
    hash.startsWith('#/lark-enterprise-entry') ||
    hash.startsWith('#/login')
  ) {
    return
  }

  if (isDingTalkEnvironment()) {
    redirectToDingTalkEnterpriseEntry({ targetUrl: fullUrl })
    return
  }

  if (isFeishuEnvironment()) {
    redirectToLarkEnterpriseEntry({ targetUrl: fullUrl })
    return
  }

  window.location.href = '/#/login'
}


